import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch, TypedUseSelectorHook, useSelector } from "react-redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import {
  toastReducer,
  tokenReducer,
  userReducer,
  generationSettingReducer,
  skuTagDetailsReducer,
} from ".";

export const CLEAR_STATE = 'CLEAR_STATE';

//state 전체 삭제
export const clearState = () => ({
  type: CLEAR_STATE,
});

const reducers = combineReducers({
  toast: toastReducer,
  token: tokenReducer,
  generation_setting: generationSettingReducer,
  user: userReducer,
  sku_tag_details: skuTagDetailsReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === CLEAR_STATE) {
    // redux-persist를 사용하는 경우 storage에서 삭제하는 코드 추가
    storage.removeItem('persist:root'); // 전체 상태 초기화
    return reducers(undefined, action); // 상태를 초기화하고 기존의 appReducer로 전달
  }
  return reducers(state, action);
};

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["toast", "token", "generation_setting", "user", "sku_tag_details"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  devTools: false,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
